import { SVGInternalIcon } from "@components:SVGInternalIcon";
import { useRBACCheck } from "@hooks:useRBAC";
import { Box, Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BiLogOut } from "react-icons/bi";
import { FaGear } from "react-icons/fa6";
import { useNavigate } from "react-router";

import { Routes } from "@:constants";
import { RBACAction, RBACResource } from "@:rbac";

/**
 * Shown when the user has no bot to use.
 * Admins are pointed to the bot settings to create one; other users to their administrator.
 */
export const NoBots = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canManageBots = useRBACCheck(
    RBACAction.read,
    RBACResource.settings__bots,
  );

  return (
    <Box
      sx={{
        background: (theme) => theme.palette.background.default,
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        paddingTop: "7rem",
      }}
    >
      <Box
        sx={{
          textAlign: "center",
          maxWidth: 560,
          px: 2,
        }}
      >
        <SVGInternalIcon icon="botIcon" sx={{ width: 96, height: 96 }} />
        <Typography
          variant="h1"
          sx={{
            marginTop: "1rem",
            fontSize: "34px",
            letterSpacing: "-0.025em",
            color: "gray.900",
          }}
        >
          {t("botSelection.noBotsAvailable")}
        </Typography>
        <Typography
          variant="h6"
          sx={{
            margin: "1.5rem",
            color: "gray.600",
          }}
        >
          {canManageBots ? t("errors.noBotsAdminBody") : t("errors.noBotsBody")}
        </Typography>
        <Box
          sx={{
            marginTop: "2.5rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            columnGap: "1.5rem",
          }}
        >
          {canManageBots && (
            <Button
              variant="contained"
              onClick={() => navigate(Routes.SettingsBots)}
              sx={{ fontWeight: "600" }}
              startIcon={<FaGear />}
            >
              {t("account.settings")}
            </Button>
          )}
          <Button
            variant={canManageBots ? "outlined" : "contained"}
            onClick={() => navigate(Routes.Logout)}
            sx={{ fontWeight: "600" }}
            startIcon={<BiLogOut />}
          >
            {t("account.logout")}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
